// packages
import { Component, h } from 'preact';
import cx from 'classnames';

// components
import CandidateRow from './components/CandidateRow';
import HeadshotCandidateRow from './components/HeadshotCandidateRow';
import Contest from './components/Contest';
import FramesChild from './components/FramesChild';

// internal
import getJSON from './utils/get-json';
import { determineDistrictTitle, lastUpdatedFormat } from './election-utils';
import { RESULTS_IN_USE, visibleCandidatesCount } from './endpoints';

import { LENGTH_OF_CHECK_INTERVAL } from './constants';

class App extends Component<{ selectedContests: string[] }, {}> {
  constructor() {
    super();

    this.state = { contests: [] };

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData() {
    const now = new Date();

    const selectedContests = this.props.selectedContests;

    const embedType = this.props.embedType;

    const asOf = lastUpdatedFormat(now);

    getJSON(RESULTS_IN_USE).then(contests => {
      const activeContests = contests.filter(contest => {
        const slug =
          embedType == 'internal'
            ? `${contest.office_slug}`
            : `${contest.office_slug}-${contest.party}`;

        return selectedContests.indexOf(slug) >= 0;
      });

      this.setState({ contests: activeContests, asOf }, this.startTimer);
    });
  }

  startTimer() {
    this.timer = window.setTimeout(this.fetchData, LENGTH_OF_CHECK_INTERVAL);
  }

  clearTimer() {
    window.clearTimeout(this.timer);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  componentDidUpdate() {}

  render() {
    const { contests, asOf } = this.state;
    const { embedType, notes, annotations } = this.props;

    const gridClass = cx({
      seat__race_wrapper: embedType == 'internal',
      'seat__contests-single': embedType == 'homepage',
    });

    return (
      <FramesChild class="embed">
        <div class={gridClass}>
          {contests.map(contest => (
            <Contest
              key={contest.id}
              contest={contest}
              columnCount={CandidateRow.columnCount}
              contestTitle={determineDistrictTitle(
                contests.filter(
                  item => item.office_slug === contest.office_slug
                )[0]
              )}
              embedType={embedType}
              partyName={contest.party}
              tableHeader={HeadshotCandidateRow.Header}
              asOf={asOf}
              annotations={annotations.filter(
                item => item.type === contest.office_slug + '-' + contest.party
              )}
              notes={notes.filter(
                item => item.type === contest.office_slug + '-' + contest.party
              )}
              source={contest.source}
              renderCandidate={(
                candidate,
                idx,
                viewAllCandidates,
                { totalVotes }
              ) => (
                <CandidateRow
                  key={candidate.id}
                  ballotName={candidate.name}
                  candidateId={candidate.id}
                  contestIsCalled={contest.is_called}
                  contestResult={contest.contest_result}
                  isIncumbent={candidate.is_incumbent}
                  isWinner={candidate.is_winner}
                  isViewable={viewAllCandidates || idx < visibleCandidatesCount}
                  party={candidate.party}
                  totalVotesInContest={totalVotes}
                  votes={candidate.votes}
                />
              )}
            />
          ))}
        </div>
      </FramesChild>
    );
  }
}

export default App;
